import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { Menu, MenuItem, MenuItemLabel } from "@/components/ui/menu";
import { HStack } from "@/components/ui/hstack";
import { Center } from "@/components/ui/center";
import React, { useState } from 'react';
import i18n from 'i18n-js';
import { studioVersion } from "../../algorithms_and_functions/studioVersion";
import { IconM } from '@/components/media/IconsV2';
import ModalSendCopy from '../modals/ModalSendCopy';
import { useDispatch, useSelector } from "react-redux";
import { backendRequest } from '@/stores/thunks';
import Toast from './Toast';
import { switchScreen } from '@/hooks/navigate';
import OpenIssueButton from "@/components/basic/OpenIssueButton";

export default function EditorHeader({ navigation, options }) {

    const [showModal, setShowModal] = useState(false)
    const dispatch = useDispatch()
    const [toast, setToast] = useState(false)
    const internal = useSelector((state) => state.settings.preview)

    async function copyWorkflowItem(id) {
        const result = await dispatch(backendRequest('STUDIO_COPY_WF', '/studio/workflow/' + id, null, 'POST', false))
        console.log('COPY', result)
        setToast(true)
        setTimeout(() => setToast(false), 5000)
    }

    console.log('EditorHeader', options)
    return (
        <HStack space='xs' className="shadow-hard-3 justify-between items-center bg-secondary-50 h-[60px] px-6">
            <Pressable onPress={() => {
                // ---
                // FIXME(@Milo): `goBack` will not work without history if subpage is opened directly.
                if (!navigation.canGoBack()) {
                    switchScreen(navigation, 'Studio', {})
                } else {
                    navigation.goBack()
                }
                // ---
            }}>
                <HStack space='xs' className="items-center">
                    <IconM className='text-secondary-900' size={24} name='keyboard-arrow-left' />
                    <Text className="text-secondary-900">{i18n.t('studio.editor.exit')}</Text>
                    {internal && <OpenIssueButton navigation={navigation} icon='bug' />}
                </HStack>
            </Pressable>
            <Menu placement='bottom left' trigger={triggerProps => {
                return (
                    <Pressable {...triggerProps} className="px-2">
                        <HStack space='xs' className="items-center">
                            <Center className="my-2 bg-[#FFFFFF] rounded-md border border-[#BEBEBE] w-[35px] h-[35px] mr-2">
                                <IconM className={options.saved ? 'text-ina-green' : 'text-error-600'} size={24} name={options.saved ? 'cloud-done' : 'cloud-off'} />
                            </Center>
                            <Text className="font-semibold text-xl text-secondary-900">{options.title}</Text>
                            <IconM className='text-secondary-900' size={18} name='keyboard-arrow-down' />
                        </HStack>
                    </Pressable>
                );
            }}>
                {options.openModal && <MenuItem onPress={() => options.openModal()} >{i18n.t('studio.flow.convertToStudioWorkflow')}</MenuItem>}
                {options.flowId && <MenuItem onPress={() => { copyWorkflowItem(options.flowId) }} textValue={i18n.t('workflowsScreen.duplicate')}>
                    <MenuItemLabel className="text-sm">{i18n.t('workflowsScreen.duplicate')}</MenuItemLabel>
                </MenuItem>}
                {options.flowId && <MenuItem onPress={() => setShowModal(true)} textValue={i18n.t('workflowsScreen.copy')}>
                    <MenuItemLabel className="text-sm">{i18n.t('workflowsScreen.copy')}</MenuItemLabel>
                </MenuItem>}
            </Menu>
            <Text>{studioVersion}</Text>
            <ModalSendCopy flowId={options.flowId} showModal={showModal} setShowModal={setShowModal} />
            <Toast top='top-[80px]' right='right-[200px]' icon='content-copy' title='studio.editor.copied' toast={toast} setToast={setToast} />
        </HStack>
    );
}
